
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import '../../../../node_modules/core-js/modules/es.symbol.constructor.js';
import '../../../../node_modules/core-js/modules/es.symbol.for.js';
import '../../../../node_modules/core-js/modules/es.symbol.key-for.js';
import '../../../../node_modules/core-js/modules/es.json.stringify.js';
import '../../../../node_modules/core-js/modules/es.object.get-own-property-symbols.js';
import '../../../../node_modules/core-js/modules/es.symbol.description.js';
import { forwardRef, useState, useEffect, useImperativeHandle } from 'react';
import classNames from '../../../../node_modules/classnames/index.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import '../../../../node_modules/deepmerge/dist/cjs.js';
import '../../../theme/default/defaultTheme.js';
import '../../../../node_modules/core-js/modules/es.string.link.js';
import '../../../theme/utils/typography.js';
import SvgIconInfo from '../../../icons/client/icon-info.svg.js';
import Tooltip from '../../Tooltip/Tooltip.js';
import '../../../theme/default/colors.js';
import '../../Alert/Alert.js';
import Text from '../../Text/Text.js';
import '../../Modal/Modal.js';
import '../../../../node_modules/core-js/modules/es.array.fill.js';
import '../../../../node_modules/core-js/modules/es.array.map.js';
import '../../../../node_modules/core-js/modules/es.array.reverse.js';
import '../../../../node_modules/core-js/modules/es.array.slice.js';
import '../../../theme/utils/breakpoints.js';
import '../../../../node_modules/core-js/modules/es.array.concat.js';
import '../../../../node_modules/core-js/modules/es.array.filter.js';
import '../../../../node_modules/core-js/modules/es.object.to-string.js';
import '../../Tabs/styles.js';
import '../../Drawer/Drawer.js';
import '../../Sidebar/Sidebar.js';
import '../../Card/Card.js';
import '../../Grid/Grid.js';
import '../../../../node_modules/core-js/modules/es.array.includes.js';
import '../../../../node_modules/core-js/modules/es.array.iterator.js';
import '../../../../node_modules/core-js/modules/es.number.constructor.js';
import '../../../../node_modules/core-js/modules/es.set.constructor.js';
import '../../../../node_modules/core-js/modules/es.string.includes.js';
import '../../../../node_modules/core-js/modules/es.string.iterator.js';
import '../../../../node_modules/core-js/modules/web.dom-collections.iterator.js';
import '../../../../node_modules/core-js/modules/es.array.find.js';
import '../../../../node_modules/core-js/modules/es.array.every.js';
import '../../../../node_modules/core-js/modules/es.array.join.js';
import '../../../../node_modules/core-js/modules/es.array.reduce.js';
import '../../../../node_modules/core-js/modules/es.object.keys.js';
import '../../../../node_modules/core-js/modules/web.set-interval.js';
import '../../../../node_modules/core-js/modules/web.set-timeout.js';
import '../Input/styles.js';
import '../../../../node_modules/core-js/modules/es.regexp.exec.js';
import '../../../../node_modules/core-js/modules/es.function.name.js';
import '../../../theme/default/config/button.js';
import '../../../theme/default/config/card.js';
import '../../../theme/default/config/chip.js';
import '../../../theme/default/config/formElements.js';
import '../../../theme/default/config/progressBar.js';
import '../../../theme/default/config/table.js';
import '../../../theme/default/config/tag.js';
import '../../../theme/default/config/pagination.js';
import '../../../theme/default/config/statusTag.js';
import { ToggleContainer } from './styles.js';

var _excluded = ["id", "labelBefore", "labelAfter", "description", "labelledById", "defaultChecked", "preventToggle", "isDisabled", "required", "hasInlineText", "inlineTextTranslations", "variant", "showOutlineBorder", "notSwitchedOff", "size", "subtitle", "tooltip", "InternalIcon", "onChange"];
var labelClassNames = function labelClassNames(customClassName, notSwitchedOff, isRequired) {
  return classNames(customClassName, {
    "binary-bold": notSwitchedOff,
    required: isRequired
  });
};
var switchClassNames = function switchClassNames(customClassName, isMedium, isSuccess) {
  return classNames(customClassName, {
    md: isMedium,
    success: isSuccess
  });
};
var ToggleSwitch = function ToggleSwitch(_ref, ref) {
  var id = _ref.id,
    labelBefore = _ref.labelBefore,
    labelAfter = _ref.labelAfter,
    description = _ref.description,
    labelledById = _ref.labelledById,
    _ref$defaultChecked = _ref.defaultChecked,
    defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
    _ref$preventToggle = _ref.preventToggle,
    preventToggle = _ref$preventToggle === void 0 ? false : _ref$preventToggle,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$hasInlineText = _ref.hasInlineText,
    hasInlineText = _ref$hasInlineText === void 0 ? false : _ref$hasInlineText,
    _ref$inlineTextTransl = _ref.inlineTextTranslations,
    inlineTextTranslations = _ref$inlineTextTransl === void 0 ? {
      enabled: "Enabled",
      disabled: "Disabled"
    } : _ref$inlineTextTransl,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "primary" : _ref$variant,
    _ref$showOutlineBorde = _ref.showOutlineBorder,
    showOutlineBorder = _ref$showOutlineBorde === void 0 ? false : _ref$showOutlineBorde,
    _ref$notSwitchedOff = _ref.notSwitchedOff,
    notSwitchedOff = _ref$notSwitchedOff === void 0 ? false : _ref$notSwitchedOff,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "sm" : _ref$size,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? "" : _ref$subtitle,
    tooltip = _ref.tooltip,
    InternalIcon = _ref.InternalIcon,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(defaultChecked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var hasDescription = Boolean(description);
  var hasDescriptionTextWeight = hasDescription ? "700" : "400";
  var isMedium = size === "md";
  var isSuccess = variant === "success";
  var hasIcon = Boolean(InternalIcon);
  useEffect(function () {
    setIsChecked(defaultChecked);
  }, [defaultChecked]);
  var handleToggle = function handleToggle(e) {
    e.stopPropagation();
    if (isDisabled) return;
    if (!preventToggle) setIsChecked(function (prev) {
      return !prev;
    });
    onChange === null || onChange === void 0 || onChange(isChecked);
  };
  useImperativeHandle(ref, function () {
    return {
      toggle: function toggle() {
        return setIsChecked(function (prev) {
          return !prev;
        });
      }
    };
  });
  return jsx("div", _extends({
    id: id,
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      return e.key === "Enter" && handleToggle(e);
    },
    css: function css(theme) {
      return ToggleContainer(theme, {
        isChecked: isChecked,
        isDisabled: isDisabled,
        hasDescription: hasDescription,
        notSwitchedOff: notSwitchedOff,
        showOutlineBorder: showOutlineBorder
      });
    },
    "data-testid": id,
    "data-checked": isChecked,
    "aria-label": tooltip
  }, rest), jsx("div", {
    className: "switch-container"
  }, labelBefore && jsx("div", {
    className: "label-description-container label-before"
  }, jsx(Text, {
    fontSize: "sm",
    className: labelClassNames("label is-before", notSwitchedOff, false),
    onClick: handleToggle,
    weight: hasDescriptionTextWeight
  }, tooltip && jsx(Tooltip, {
    content: tooltip,
    parentProps: {
      "aria-label": tooltip
    }
  }, jsx(SvgIconInfo, {
    height: 16
  })), labelBefore), jsx(Text, {
    fontSize: "sm",
    as: "div",
    className: "description-text"
  }, description)), jsx("div", {
    className: "switch-container"
  }, jsx("div", {
    "data-testid": "switch",
    "data-checked": isChecked,
    className: switchClassNames("switch", isMedium, isSuccess),
    onClick: handleToggle,
    role: "switch",
    "aria-checked": isChecked,
    "aria-labelledby": labelledById
  }, hasInlineText && isMedium && jsx(Text, {
    fontSize: "sm",
    className: "inline-text"
  }, isChecked ? inlineTextTranslations.enabled : inlineTextTranslations.disabled), hasIcon && jsx("div", {
    className: "internal-icon"
  }, InternalIcon), jsx("div", {
    className: switchClassNames("thumb", isMedium, isSuccess)
  }))), labelAfter && jsx("div", {
    className: "label-description-container label-after"
  }, jsx(Text, {
    fontSize: "sm",
    className: labelClassNames("label", notSwitchedOff, required),
    onClick: handleToggle,
    as: "div",
    weight: hasDescriptionTextWeight
  }, labelAfter, tooltip && jsx(Tooltip, {
    content: tooltip,
    parentProps: {
      "aria-label": tooltip
    }
  }, jsx(SvgIconInfo, {
    height: 16
  }))), description && jsx(Text, {
    fontSize: "sm",
    as: "div",
    className: "description-text"
  }, description))), subtitle && jsx("div", {
    className: "subtitle-text"
  }, jsx(Text, {
    fontSize: "sm"
  }, subtitle)));
};
var ToggleSwitch$1 = /*#__PURE__*/forwardRef(ToggleSwitch);

export { ToggleSwitch$1 as default };
//# sourceMappingURL=ToggleSwitch.js.map
